import { render, staticRenderFns } from "./AllTestResults.vue?vue&type=template&id=13690298&"
import script from "./AllTestResults.vue?vue&type=script&lang=js&"
export * from "./AllTestResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports